// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"55b94394","748":"d1f283ee","851":"ed78cead","865":"6911fe3a"}[chunkId] + ".chunk.js";
};